import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { IManufacturingSearchResult } from "../../declarations/ManufacturingSearch";

const searchForManufacturingItems = async (
    searchTerm: string,
): Promise<IManufacturingSearchResult[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<IManufacturingSearchResult[]>(
        "/ManufacturingSearch/SearchForManufacturingItems",
        { searchTerm },
    );
    return response.data;
};

export const useSearchForManufacturingItems = (searchTerm: string) =>
    useQuery<IManufacturingSearchResult[]>({
        enabled: searchTerm.length > 3,
        queryFn: () => searchForManufacturingItems(searchTerm!),
        queryKey: ["SearchForManufacturingItems", searchTerm],
        refetchOnWindowFocus: false,
        retry: false,
        select: (data) => data ?? [],
    });
